// ============================================================================
// RATE PLAN ENDPOINTS
// ============================================================================
// Endpoint definitions for Rate Plan module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

/**
 * Base path for rate plan endpoints (matches RatePlanController route)
 */
const BASE_PATH = '/RatePlan';

/**
 * Rate Plan Endpoints
 */
export const ratePlanEndpoints = {
  /**
   * Get all rate plans (paginated)
   * GET /RatePlan
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get rate plan by ID
   * GET /RatePlan/:id
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Create new rate plan
   * POST /RatePlan
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update rate plan
   * PUT /RatePlan/:id
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete rate plan
   * DELETE /RatePlan/:id
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
} as const;

/**
 * Export endpoints
 */
export default ratePlanEndpoints;
